var React = require('react');

function IcPaper (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6Zm2 10H8v2h8v-2Zm0 4H8v2h8v-2ZM6 20h12V9h-5V4H6v16Z","fill":"currentColor"}));
}

IcPaper.defaultProps = {"width":"24","height":"24"};

module.exports = IcPaper;

IcPaper.default = IcPaper;
